import React from 'react';
import { ArrowDown, ArrowRight, Sparkles } from 'lucide-react';
import { BEFORE_AFTER } from '../../lib/marketing';

export const BeforeAfter = () => (
  <div className="grid items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr]" data-testid="before-after">
    <div className="rounded-2xl border border-border bg-white p-6 sm:p-8">
      <span className="inline-flex rounded-full bg-muted px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">Before</span>
      <p className="mt-5 text-lg leading-relaxed text-primary/80 sm:text-xl">“{BEFORE_AFTER.before}”</p>
      <p className="mt-6 text-sm text-muted-foreground">Vague, no scope, no channels, no result.</p>
    </div>
    <div className="flex items-center justify-center text-accent" aria-hidden="true">
      <span className="flex h-11 w-11 items-center justify-center rounded-full border border-accent/30 bg-accent/5"><ArrowDown className="h-5 w-5 lg:hidden" /><ArrowRight className="hidden h-5 w-5 lg:block" /></span>
    </div>
    <div className="rounded-2xl border border-accent/30 bg-white p-6 shadow-[0_24px_48px_-24px_rgba(37,99,235,0.35)] sm:p-8">
      <span className="inline-flex items-center gap-1 rounded-full bg-accent px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-white"><Sparkles className="h-3 w-3" aria-hidden="true" /> After</span>
      <p className="mt-5 text-lg font-medium leading-relaxed text-primary sm:text-xl">“{BEFORE_AFTER.after}”</p>
      <ul className="mt-6 flex flex-wrap gap-2" aria-label="What changed">
        {BEFORE_AFTER.labels.map((l) => <li key={l} className="rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">{l}</li>)}
      </ul>
    </div>
  </div>
);
